import React, { useContext } from 'react';
import { getText, TEXT_KEY } from 'shared/utils/localization';
import ThemeContext from 'shared/context/ThemeContext';
import CopySelector from 'shared/utils/copySelector';
import ImageBoundsWrapper from '../../../../components/ImageBoundsWrapper';
import { styles } from '../../styles';

const activeCheckbox = require(asset`Checkbox@3x.png`);
const nonActiveCheckbox = require(asset`Checkbox_Deselected@3x.png`);

const DefaultFormFooter = ({
  handleRegisterRewardCard,
  handleOpenTerms,
  enableOrderCard,
  showOTPConsents,
  activeOTPCheckbox,
  handleOPTCheckbox,
  selectedPropertyObj,
}) => {
  const { FormFooter } = useContext(ThemeContext);

  return (
    <>
      {showOTPConsents ? (
        <div style={styles.otpConsentsContainer}>
          <ImageBoundsWrapper
            source={activeOTPCheckbox ? activeCheckbox : nonActiveCheckbox}
            ibw={require(asset`Checkbox.ibw`)}
            style={styles.otpConsentsCheckbox}
            className="checkbox-image"
            onClick={handleOPTCheckbox}
          />
          <p style={styles.otpConsentsText}>
            {enableOrderCard && (
              <>
                {`${CopySelector.getCopy(CopySelector.COPY_TYPES.LINK_CARD_SIGNUP)}`}{' '}
                <a style={FormFooter.TermsLink} onClick={handleRegisterRewardCard}>
                  {CopySelector.getCopy(CopySelector.COPY_TYPES.LINK_CARD_SIGNUP_CTA)}
                </a>{' '}
              </>
            )}
            {CopySelector.getCopy(CopySelector.COPY_TYPES.LINK_CARD_OTP_CONSENTS)}
            <br />
            <a style={FormFooter.TermsLink} onClick={() => window.open(selectedPropertyObj.termsAndConditionsURL)}>
              {getText(TEXT_KEY.TERMS_OF_SERVICE)}
            </a>{' '}
            {getText(TEXT_KEY.AND)}{' '}
            <a style={FormFooter.TermsLink} onClick={() => window.open(selectedPropertyObj.privacyPolicyURL)}>
              {getText(TEXT_KEY.PRIVACY_POLICY)}
            </a>{' '}
          </p>
        </div>
      ) : (
        <p style={styles.termsText}>
          {enableOrderCard && (
            <>
              {`${CopySelector.getCopy(CopySelector.COPY_TYPES.LINK_CARD_SIGNUP)}`}{' '}
              <a style={FormFooter.TermsLink} onClick={handleRegisterRewardCard}>
                {CopySelector.getCopy(CopySelector.COPY_TYPES.LINK_CARD_SIGNUP_CTA)}
              </a>{' '}
            </>
          )}
          {getText(TEXT_KEY.TERMS_AGREE_MESSAGE)}{' '}
          <a style={FormFooter.TermsLink} onClick={() => handleOpenTerms('TERMS')}>
            {getText(TEXT_KEY.TERMS_OF_SERVICE)}
          </a>
        </p>
      )}
    </>
  );
};

export default DefaultFormFooter;

